import React, { useEffect, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { getScanSoundEnabled, setScanSoundEnabled, SCAN_SOUND_CHANGED_EVENT } from '../../utils/scanFeedback';

// Header button that mutes / unmutes scan beeps on this device
const SoundToggle = ({ className = 'header-icon-button' }) => {
  const [enabled, setEnabled] = useState(getScanSoundEnabled);

  // Stay in sync if the setting changes elsewhere (another toggle, another tab)
  useEffect(() => {
    const sync = () => setEnabled(getScanSoundEnabled());
    window.addEventListener(SCAN_SOUND_CHANGED_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(SCAN_SOUND_CHANGED_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return (
    <button
      type="button"
      className={className}
      aria-pressed={enabled}
      aria-label="Scan sounds"
      title={enabled ? 'Scan sounds on' : 'Scan sounds off'}
      onClick={() => setScanSoundEnabled(!enabled)}
    >
      {enabled ? <Volume2 size={18} aria-hidden="true" /> : <VolumeX size={18} aria-hidden="true" />}
    </button>
  );
};

export default SoundToggle;
